import { InlineLink, Text, Tooltip } from '@fullstory/components';
import { generateRoutePath, SETTINGS_BILLING } from '@fullstory/routes';
import React, { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

interface SessionListItemButtonProps {
  insideRetentionWindow: boolean;
  retentionWindowInMonths: number;
  orgId: string;
}

export const SessionListItemButton: React.FC<PropsWithChildren<SessionListItemButtonProps>> = ({
  insideRetentionWindow,
  retentionWindowInMonths,
  orgId,
  children,
}) => {
  if (!insideRetentionWindow) {
    return (
      <Tooltip
        data-component="SessionInfoUnavailable"
        placement="top"
        tooltipContent={
          <Text appearance="bodySmall" color="default-inverse">
            <FormattedMessage
              defaultMessage="Only sessions from the last {retentionWindowInMonths} months are available. For more details, go to <link>Subscription</link>."
              id="3BkwHR"
              values={{
                link(text) {
                  return (
                    <InlineLink
                      to={generateRoutePath(SETTINGS_BILLING, { orgId })}
                      variant="inverse"
                    >
                      {text}
                    </InlineLink>
                  );
                },
                retentionWindowInMonths,
              }}
            />
          </Text>
        }
      >
        {children}
      </Tooltip>
    );
  }

  return <>{children}</>;
};
